//import icons from '../img/icons.svg'; //Parcel 1
import icons from 'url:../../img/icons.svg'; //Parcel 2
import { Fraction } from 'fractional';
import html2pdf from 'html2pdf.js';
import View from './View.js';

class ShoppingCartView extends View {
  _parentElement = document.querySelector('.recipe');
  _navCartBtn = document.querySelector('.nav__btn--cart');
  _errorMessage = `This Recipe is already in the shopping list`;
  _message = ``;

  addHandlerPrintRecipe(handler) {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn__print--item');
      if (!btn) return;

      //data-html2canvas-ignore="true"
      const printingRecipe = btn.closest('.cart__item--content');
      let opt = {
        margin: 1,
        filename: 'Shopping List.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };
      html2pdf().from(printingRecipe).set(opt).save();
    });
  }

  addHandlerNavCartBtn(handler) {
    this._navCartBtn.addEventListener('click', function () {
      //setting the current url hash to '#'
      window.location.hash = '#';
      handler();
    });
  }

  addHandlerRemoveItem(handler) {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn__remove--item');
      if (!btn) return;
      const removeItemIndex = +btn.getAttribute('data-cartItem');
      handler(removeItemIndex);
    });
  }

  //href="${this._originURL}/#${res.id}"
  addHandlerViewRecipe(handler) {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn__view--item');
      if (!btn) return;
      const recipeId = btn.getAttribute('data-viewResID');
      window.location.hash = `#${recipeId}`;
      handler();
    });
  }

  renderCartNotificationOnRemove(shoppingList) {
    const cartNotification = document.querySelector('.cart-notification');
    cartNotification.textContent = shoppingList.length;

    if (shoppingList.length === 0) {
      cartNotification.classList.add('hidden');
    }
  }

  cartNotifyOnPageLoad(handler, shoppingList) {
    const cartNotification = document.querySelector('.cart-notification');
    window.addEventListener('load', function () {
      if (shoppingList.length > 0) {
        cartNotification.textContent = shoppingList.length;
        cartNotification.classList.remove('hidden');
      }
      handler();
    });
  }

  _cartParentElementMarkup = `
      <div class="cart">
          <div class="cart__wrapper">
            <div class="cart__heading">
            </div>
            <div class="cart__item--container"></div>
          </div>
        </div>`;

  _generateMarkup() {
    /*  return `${this._data.map(this._generateMarkupCartItem).join('')}`; */
    /* this._data.splice(-1); */
    return `${this._data
      .map((res, i) => {
        return `
        <div class="cart">
          <div class="cart__wrapper">
            <div class="cart__heading"><h1>Ingredient Shopping List ${
              i + 1
            }</h1></div>
        <div class="cart__item--container">
          <div class="cart__item">
            <figure class="cart__item--fig">
              <img src="${res.image}" alt="${res.title}" />
            </figure>
            <div class="cart__item--content">
              <div class="ing__heading">${res.title}</div>
              <div class="ing__content">
                ${res.ingredients.map(this._generateMarkupIngredient).join('')}
              </div>
              <div class="ing__buttons" data-html2canvas-ignore="true">
                <button class="btn btn__print--item">
                <svg id="icon-print" viewBox="0 0 24 24"><path d="M16 18h-8v-1h8v1zm-2 1h-6v1h6v-1zm10-14v13h-4v6h-16v-6h-4v-13h4v-5h16v5h4zm-18 0h12v-3h-12v3zm12 10h-12v7h12v-7zm4-8h-20v9h2v-3h16v3h2v-9zm-1.5 1c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z"/></svg>
                  <span>Print</span>
                </button>
                <button data-viewResID="${res.id}" class="btn btn__view--item" >
                <svg id="icon-view" viewBox="0 0 24 24"><path d="M15 12c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-.199.02-.393.057-.581 1.474.541 2.927-.882 2.405-2.371.174-.03.354-.048.538-.048 1.657 0 3 1.344 3 3zm-2.985-7c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 12c-2.761 0-5-2.238-5-5 0-2.761 2.239-5 5-5 2.762 0 5 2.239 5 5 0 2.762-2.238 5-5 5z"/></svg>
                  <span>View Recipe</span>
                </button>
                <button data-cartItem="${i}" class="btn btn__remove--item" >
                <svg id="icon-remove-cart" viewBox="0 0 24 24"><path d="M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm9.805-16.5l-3.432 12h-2.102l2.541-9h-5.993c.115.482.181.983.181 1.5 0 3.59-2.91 6.5-6.5 6.5-.407 0-.805-.042-1.191-.114l1.306 3.114h13.239l3.474-12h1.929l.743-2h-4.195zm-6.305 15c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm-4.5-10.5c0 2.485-2.018 4.5-4.5 4.5-2.484 0-4.5-2.015-4.5-4.5s2.016-4.5 4.5-4.5c2.482 0 4.5 2.015 4.5 4.5zm-2-.5h-5v1h5v-1z"/></svg>
                  <span>Remove</span>
                </button>
              </div>
            </div>
          </div>
          </div>
          </div>
          </div>
        `;
      })
      .join('')}`;
  }

  _generateMarkupIngredient(ing) {
    return `
        <li class="ing__ingredient">
            <svg class="ing__icon">
                <use href="${icons}#icon-check"></use>
            </svg>
            <div class="ing__quantity">${
              ing.quantity ? new Fraction(ing.quantity).toString() : ''
            }</div>
            <div class="ing__description">
            <span class="ing__unit">${ing.unit}</span>
            ${ing.description}
            </div>
        </li>
      `;
  }
}

export default new ShoppingCartView();
